import { render, staticRenderFns } from "./ChallengeItem.vue?vue&type=template&id=07e36d24&scoped=true"
import script from "./ChallengeItem.vue?vue&type=script&lang=js"
export * from "./ChallengeItem.vue?vue&type=script&lang=js"
import style0 from "./ChallengeItem.vue?vue&type=style&index=0&id=07e36d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e36d24",
  null
  
)

export default component.exports